import styled, { createGlobalStyle } from "styled-components";

const RootHome = styled.div`
  display: flex;
  width: 100%;
`;

const HomeContainer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  height: calc(100svh - 1.75rem);
  overflow-x: hidden;
  width: 100%;
  font-family: 'Inter', sans-serif;
`;

const MainArea = styled.div`
  display: inherit;
  padding: ${(props) => props.$isDocumentEditMode ? '0' : '2em'};
  flex-direction: row;
  grid-column: 2 / 3;
  transition: grid-column 0.3s ease, width 0.3s ease, padding 0.3s ease;
  max-height: calc(100svh - 76px);
  width: ${(props) => props.$isDocumentEditMode ? '100%' : (props.isDesktop ? '80%' : '100%')};
  margin-left: ${(props) => props.$isDocumentEditMode ? '0' : 'auto'};
  margin-right: ${(props) => props.$isDocumentEditMode ? '0' : 'auto'};

  @media (max-width: 768px) {
    display: flex;
    padding: 1em;
    max-height: fit-content;
  }

  @media (max-width: 1024px) {
    height: calc(100vh - 80px);
    overflow-y: auto;
  }
`;

const BodyChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: ${(props) => props.isChatQuestionsVisible ? 'auto' : '100%'};

  @media (max-width: 768px) {
    padding: 10px;
    margin-bottom: 0;
  }
`;

const ChatContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => props.isChatQuestionsVisible ? 'center' : 'space-between' } ;
`;

const SearchContainer = styled.div`
  position: relative;
  width: 400px;
  display: flex;
  justify-content: center;
  z-index: 4;
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.clearGray};
  background: ${(props) => props.theme.colors.white};
  height: 46px;
  padding-right: 5px;
`;

const InputField = styled.input`
  width: 100%;
  height: 35px;
  border: none;
  outline: none;
  padding: 0 10px;
  background: ${(props) => props.theme.colors.white};
  ${(props) => props.theme.fonts.variant.regular()};

  ::placeholder {
    color: ${(props) => props.theme.colors.clearGray};
  }
`;

const SearchIcon = styled.div`
  display: block;
  margin: auto;
`;

const FooterChatContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 10px;
  position: relative;


  &.footer-chat-container > div > div:first-child {
    display: none;
  }

  &.footer-chat-container > div > div:nth-child(2) {
    width: 100%;
  }

  @media (max-width: 768px) {
    padding: 8px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
  }

  @media (max-width: 480px) {
    padding: 5px;
  }
`;

const MessageInputField = styled.input`
  width: 100%;
  height: 30px;
  outline: none;
  padding: 0 10px;
  border: none;
  background: ${(props) => props.theme.colors.silverGrayThree};
  ${(props) => props.theme.fonts.variant.regular()};

  ::placeholder {
    color: ${(props) => props.theme.colors.clearGray};
  }
`;

const ChatInputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 5px;
  gap: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
  }

  @media (max-width: 480px) {
    padding: 3px;
    gap: 5px;
  }

  & > * {
    width: 100%;
  }

  & > div:first-child {
    flex: 1;
  }

  & > div:last-child {
    display: flex;
    justify-content: flex-end;
  }

  @media (max-width: 768px) {
    & > div:last-child {
      justify-content: center;
    }
  }


`;

const ChatConversationContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  height: auto;
  gap: ${({ isChatQuestionsVisible, isMobile }) => (isChatQuestionsVisible ? (isMobile ? '0px' : '80px') : '0px')};
  align-items: ${({ isChatQuestionsVisible }) => (isChatQuestionsVisible ? 'center' : 'flex-start')};

  &.chat-conversation-container > div > div > div {
    background: none;
    font-weight: normal;
  }
`;

const ChatWindowWrapper = styled.div`
  overflow-y: auto;
  width: 100%;
  height: 100%;
`;

const Separator = styled.div`
  width: 60px;
  height: 60px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 8px;
  margin-left: 8px;
  height: 45px;

  & > div:first-child {
    cursor: pointer;
  }

  & > div:last-child {
    cursor: pointer;
  }
`;

const InfoContainer = styled.div`
  width: auto;
  height: auto;
`;

const TimeContainer = styled.div`
  width: auto;
  height: auto;
`;

const WelcomeContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  color: ${(props) => props.theme.colors.black};
  font-weight: normal;
`;

const ImageContainer = styled.div`
  width: 70px;
  height: auto;
  margin: 20px auto;
  display: flex;
  justify-content: center;
`;

const AgentWelcomeContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-align: center;
  color: ${(props) => props.theme.colors.davysGrey};
  opacity: 0.8;
  font-weight: normal;
  font-size: 16px;
`;

const AgentWelcomeText = styled.div`
  margin-bottom: 10px;
  max-width: 574px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 6; /* Approximately 150 characters for this font size */
  -webkit-box-orient: vertical;
`;

const AgentNameText = styled.div`
  margin-bottom: 10px;
  font-weight: bold !important;
  font-size: 22px;
`;

const ChatWindowComponentWrapper = styled.div`
  & #chat-window-component-wrapper > div > div {
    width: 100% !important;
  }
`;

const CenteredSpinner = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
`;

const CustomGenericListStyle = createGlobalStyle`
  #main-content {
    overflow: hidden;
  }
  
  #main-content > div:first-child{
    background: ${(props) => props.theme.colors.white};
  }
`;

const ResponsiveMainArea = styled(MainArea)`
  @media (max-width: 1024px) {
    height: calc(100vh - 60px);
    overflow: hidden;
  }
`;

const ResponsiveChatContainer = styled(ChatContainer)`
  @media (max-width: 768px) {
    height: calc(100vh - 110px);
  }
`;

const ResponsiveBodyChatContainer = styled(BodyChatContainer)`
  @media (max-width: 768px) {
    padding: 0.5rem;
    height: calc(100% - 60px); // Adjust for footer height
  }
`;

const ResponsiveFooterChatContainer = styled(FooterChatContainer)`
  @media (max-width: 768px) {
    position: relative;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    padding: 0.5rem;
    background-color: ${(props) => props.theme.colors.white};
  }
`;

const AgentImage = styled.img`
    height: 60px;
    width: 60px;
    border-radius: 50%;
    object-fit: cover;
`;

const TabsContent = styled.div`
`

const ModelSelectorBar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: ${props => props.theme.colors.backgroundLight || '#f8f9fa'};
  border-radius: 12px 12px 0 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  
  @media (max-width: 768px) {
    padding: 10px 12px;
    gap: 8px;
  }
`;

const ModelSelectLabel = styled.span`
  font-size: 13px;
  color: #666;
  font-weight: 500;
  white-space: nowrap;
  line-height: 1;
`;

export {
  HomeContainer,
  MainArea,
  ChatContainer,
  InputWrapper,
  InputField,
  SearchIcon,
  SearchContainer,
  BodyChatContainer,
  FooterChatContainer,
  MessageInputField,
  ChatInputWrapper,
  ChatConversationContainer,
  ChatWindowWrapper,
  Separator,
  ButtonsContainer,
  InfoContainer,
  TimeContainer,
  WelcomeContainer,
  ImageContainer,
  AgentWelcomeContainer,
  AgentWelcomeText,
  AgentNameText,
  ChatWindowComponentWrapper,
  CenteredSpinner,
  CustomGenericListStyle,
  RootHome,
  ResponsiveMainArea,
  ResponsiveChatContainer,
  ResponsiveBodyChatContainer,
  ResponsiveFooterChatContainer,
  AgentImage,
  TabsContent,
  ModelSelectorBar,
  ModelSelectLabel,
};